import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import MuiPopover from '@material-ui/core/Popover'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import SvgIcon from '@material-ui/core/SvgIcon'
import { ReactComponent as IconClose } from 'assets/icons/close.svg'
import useStyles from './styles'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const Popover = props => {
  const {
    id,
    open,
    title,
    onClose,
    anchorEl,
    anchorOrigin,
    transformOrigin,
    children,
    actions,
  } = props

  const classes = useStyles()

  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('xs'))

  return (
    <MuiPopover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      elevation={3}
      className={clsx(classes.root, isSmall && classes.popoverXS)}
      marginThreshold={0}
    >
      <DialogTitle
        id="customized-dialog-title"
        className={classes.dialogTitle}
        onClose={onClose}
        disableTypography={true}
      >
        <Typography variant="h2" className={classes.titleText}>
          {title}
        </Typography>
        <IconButton
          aria-label="close"
          className={classes.dialogClose}
          onClick={onClose}
        >
          <SvgIcon component={IconClose} />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        {children}
      </DialogContent>
      {actions ? (
        <DialogActions className={classes.dialogActions}>
          {actions}
        </DialogActions>
      ) : null}
    </MuiPopover>
  )
}

Popover.propTypes = {
  id: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  anchorEl: PropTypes.object,
  anchorOrigin: PropTypes.object,
  transformOrigin: PropTypes.object,
  children: PropTypes.element,
  actions: PropTypes.element,
}

export default Popover
